// 全站路由与 SEO 配置
import { APP_INFO } from '@/data/app-info';

const SITE = 'https://gbwhatts.net';

function route(path, name, pageKey, meta) {
  return {
    path,
    name,
    meta: {
      appname: 'GBWhatsApp',
      pageKey,
      ...meta,
      link: [{ rel: 'canonical', href: `${SITE}${path.endsWith('/') ? path : path + '/'}` }],
    },
    component: () => import('@/views/DynamicPage.vue'),
  };
}

export const siteRoutes = [
  // Core
  route('/gb-whatsapp-latest-version', 'en-latest-version', 'latest-version', {
    title: 'Page to Download GB WhatsApp Latest APK',
    keywords: 'gb whatsapp latest version, gb whatsapp download, gbwhatsapp apk latest',
    description: 'Get the latest GB WhatsApp APK for Android on this page. Fast download, newest version, and easy setup in just a few steps.',
  }),
  route('/gb-whatsapp-update', 'en-update', 'update', {
    title: 'GB WhatsApp Update – How to Get the Latest Version',
    keywords: 'gb whatsapp update, gbwhatsapp update, update gb whatsapp apk',
    description: 'Learn how to update GB WhatsApp to the latest version without losing chats. Step-by-step update guide for Android.',
  }),
  route('/gb-whatsapp-install', 'en-install', 'install', {
    title: 'How to Install GB WhatsApp APK on Android – Step by Step',
    keywords: 'gb whatsapp install, gbwhatsapp install guide, install gb whatsapp apk',
    description: 'Complete GB WhatsApp install guide for Android. Enable unknown sources, download APK, verify number, and restore chats.',
  }),
  route('/gb-whatsapp-old-versions', 'en-old-versions', 'old-versions', {
    title: 'GB WhatsApp Old Versions Download – Previous APK Files',
    keywords: 'gb whatsapp old version, gbwhatsapp old apk, previous gb whatsapp version',
    description: 'Download older GB WhatsApp APK versions if the latest update causes issues. Archive of stable previous builds.',
  }),

  // Troubleshooting
  route('/gb-whatsapp-not-installing', 'en-not-installing', 'not-installing', {
    title: 'GB WhatsApp Not Installing? Here Are the Fixes',
    keywords: 'gb whatsapp not installing, gbwhatsapp install error, app not installed',
    description: 'GB WhatsApp won\'t install? Fix unknown sources, storage, signature mismatch, and corrupted download issues.',
  }),
  route('/gb-whatsapp-not-connecting', 'en-not-connecting', 'not-connecting', {
    title: 'GB WhatsApp Not Connecting – Network Fix Guide',
    keywords: 'gb whatsapp not connecting, gbwhatsapp connection problem, stuck on connecting',
    description: 'Fix GB WhatsApp connection issues. Steps for stuck on connecting, network errors, and server problems.',
  }),
  route('/gb-whatsapp-otp-not-received', 'en-otp', 'otp-not-received', {
    title: 'GB WhatsApp OTP Not Received – Verification Help',
    keywords: 'gb whatsapp otp not received, gbwhatsapp verification code, otp problem',
    description: 'Not getting your GB WhatsApp verification code? Fix SMS delays, blocked messages, and OTP errors.',
  }),
  route('/gb-whatsapp-update-failed', 'en-update-failed', 'update-failed', {
    title: 'GB WhatsApp Update Failed – How to Fix It',
    keywords: 'gb whatsapp update failed, gbwhatsapp update error, cannot update',
    description: 'GB WhatsApp update won\'t install? Fix signature mismatch, storage issues, and failed update errors.',
  }),
  route('/gb-whatsapp-restore-backup', 'en-restore-backup', 'restore-backup', {
    title: 'How to Restore GB WhatsApp Backup – Chat Recovery',
    keywords: 'gb whatsapp restore backup, gbwhatsapp chat backup, recover chats',
    description: 'Restore your GB WhatsApp chats from Google Drive or local backup after reinstalling the app.',
  }),
  route('/gb-whatsapp-banned-account-fix', 'en-banned', 'banned-account', {
    title: 'GB WhatsApp Banned Account – What to Do',
    keywords: 'gb whatsapp banned, gbwhatsapp ban fix, temporarily banned',
    description: 'GB WhatsApp account banned? Learn about temporary vs permanent bans and how to recover your account.',
  }),

  // Comparison
  route('/gb-whatsapp-vs-whatsapp', 'en-vs-whatsapp', 'vs-whatsapp', {
    title: 'GB WhatsApp vs Official WhatsApp – Honest Comparison',
    keywords: 'gb whatsapp vs whatsapp, gbwhatsapp comparison, official whatsapp vs gb',
    description: 'Compare GB WhatsApp and official WhatsApp features, privacy, themes, file sharing, and safety side by side.',
  }),
  route('/gb-whatsapp-vs-fm-whatsapp', 'en-vs-fm', 'vs-fm', {
    title: 'GB WhatsApp vs FM WhatsApp – Which Mod Is Better?',
    keywords: 'gb whatsapp vs fm whatsapp, fmwhatsapp vs gbwhatsapp',
    description: `GB WhatsApp vs FM WhatsApp compared. Features, themes, privacy, and which mod to choose in ${APP_INFO.year}.`,
  }),
  route('/gb-whatsapp-vs-yowhatsapp', 'en-vs-yo', 'vs-yo', {
    title: 'GB WhatsApp vs YoWhatsApp – Feature Comparison',
    keywords: 'gb whatsapp vs yowhatsapp, yowa vs gbwhatsapp',
    description: 'Compare GB WhatsApp and YoWhatsApp. See differences in features, design, privacy, and file sharing.',
  }),
  route('/gb-whatsapp-vs-whatsapp-plus', 'en-vs-plus', 'vs-plus', {
    title: 'GB WhatsApp vs WhatsApp Plus – Full Comparison',
    keywords: 'gb whatsapp vs whatsapp plus, whatsapp plus vs gbwhatsapp',
    description: `GB WhatsApp vs WhatsApp Plus compared. Which mod has better features, updates, and safety in ${APP_INFO.year}?`,
  }),

  // Safety
  route('/is-gb-whatsapp-safe', 'en-is-safe', 'is-safe', {
    title: `Is GB WhatsApp Safe? Honest Risk Assessment ${APP_INFO.year}`,
    keywords: 'is gb whatsapp safe, gbwhatsapp safe, gb whatsapp security',
    description: 'Is GB WhatsApp safe to use? Balanced look at risks, benefits, ban concerns, and how to download safely.',
  }),
  route('/is-gb-whatsapp-legal', 'en-is-legal', 'is-legal', {
    title: 'Is GB WhatsApp Legal? What You Should Know',
    keywords: 'is gb whatsapp legal, gbwhatsapp legal status, is mod whatsapp legal',
    description: 'Is GB WhatsApp legal? Understand the legal status, WhatsApp terms of service, and user risks.',
  }),
  route('/gb-whatsapp-ban-risk', 'en-ban-risk', 'ban-risk', {
    title: 'GB WhatsApp Ban Risk – How to Stay Safe',
    keywords: 'gb whatsapp ban risk, gbwhatsapp anti ban, avoid whatsapp ban',
    description: 'Understand GB WhatsApp ban risk. Learn what triggers bans and how to reduce your chances of getting banned.',
  }),
  route('/gb-whatsapp-virus-check', 'en-virus-check', 'virus-check', {
    title: 'GB WhatsApp Virus Check – Is the APK Clean?',
    keywords: 'gb whatsapp virus, gbwhatsapp malware, apk virus check',
    description: 'How to check if your GB WhatsApp APK is clean. Virus scan tips and how to avoid malware downloads.',
  }),

  // Trust
  route('/about', 'en-about', 'about', {
    title: 'About Us – gbwhatts.net',
    keywords: 'about gbwhatts, gb whatsapp download site',
    description: 'About gbwhatts.net — an independent GB WhatsApp information and download resource website.',
  }),
  route('/disclaimer', 'en-disclaimer', 'disclaimer', {
    title: 'Disclaimer – gbwhatts.net',
    keywords: 'gbwhatts disclaimer, gb whatsapp disclaimer',
    description: 'Disclaimer for gbwhatts.net. We are not affiliated with WhatsApp or Meta. Use GB WhatsApp at your own risk.',
  }),
  route('/privacy-policy', 'en-privacy', 'privacy', {
    title: 'Privacy Policy – gbwhatts.net',
    keywords: 'gbwhatts privacy policy, gb whatsapp site privacy',
    description: 'Privacy policy for gbwhatts.net. Learn what data we collect and how we protect your information.',
  }),
  route('/contact', 'en-contact', 'contact', {
    title: 'Contact Us – gbwhatts.net',
    keywords: 'contact gbwhatts, gb whatsapp support email',
    description: 'Contact the gbwhatts.net team. Questions, feedback, and broken link reports welcome.',
  }),
];
